import {
  SURVEY_GET_DETAILS,
  SURVEY_GET_DETAILS_SUCCESS,
  SURVEY_GET_DETAILS_ERROR,
  SURVEY_DELETE_QUESTION,
  UPT_QUES_OBJ,
  SURVEY_SAVE,
  SURVEY_DELETE_PAGE,
  MOVE_QUES_UP,
  MOVE_QUES_DOWN,
  UPT_LAUNCH,
  UPT_LAUNCH_SERVER,
  ADD_QUES,
  UPT_QUES,
  UPT_FORM,
  SET_BRANCHING,
  UPT_TO_SERVER,
  SET_ACTIVE,
  SET_FORCE,
  SURVEY_LIST_DEL,
  SURVEY_LIST_DEL_SUCCESS,
  SURVEY_LIST_DEL_ERROR,
  FETCH_USER,
  UPT_USER,
  SURVEY_UPTSTRUC,
  SET_ROUND,
  UPT_PWI,
  SET_LOAD
} from '../actions';


import AccessLst from './accesslist.json';

const INIT_STATE = {
  survey: null,
  launchDate: undefined,
  loading: false,
  unsave: false,
  done: false,
  surveyAssign: [],
  userAccessPerSurvey: null,
  chartPWI: '',
  access: 1,
  accessname: '',
  accesslist: AccessLst,
  selectObj: [],
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SURVEY_GET_DETAILS:
      return { ...state, loading: false, survey: null};

    case SURVEY_GET_DETAILS_SUCCESS:
      const permiss = action.payload.privilege
      if (action.payload.access.editable == 1 && permiss.role != 'owner' && permiss.autherize.view == 1 && permiss.autherize.edit == 0 && permiss.autherize.delete == 0) {
        return { ...state, unsave: false, loading: true, survey: action.payload.data[0], done: true, access: 3, accessname: action.payload.access.editname, userAccessPerSurvey: permiss };
      }
      return { ...state, unsave: false, loading: true, survey: action.payload.data[0], done: true, access: action.payload.access.editable, accessname: action.payload.access.editname, userAccessPerSurvey: permiss };

    case SURVEY_GET_DETAILS_ERROR:
      return { ...state, loading: true, unsave: false, error: action.payload };

    case SURVEY_DELETE_QUESTION:
      return { ...state, loading: false };

    case SURVEY_UPTSTRUC:
      if (action.payload == undefined) {
        return { ...state, unsave: false, loading: true };
      }
      if (action.payload.round == undefined) {
        return { ...state, unsave: false, loading: true, survey: action.payload.sur };
      }
      return { ...state, unsave: false, loading: true, survey: action.payload.sur, launchDate: action.payload.round };

    case SURVEY_SAVE:
      return { ...state, unsave: false, loading: true, survey: action.payload };

    case UPT_PWI:
      return { ...state, unsave: false, loading: true, chartPWI: action.payload };

    case SURVEY_DELETE_PAGE:
      return { ...state, loading: false };

    case ADD_QUES:
      return { ...state, loading: false };

    case UPT_QUES:
      return { ...state, loading: false };

    case UPT_FORM:
      return { ...state, loading: false };

    case UPT_QUES_OBJ:
      return { ...state, loading: false };

    case SET_BRANCHING:
      return { ...state, loading: true, selectObj: action.payload };

    case SET_ROUND:
      return { ...state, loading: true, launchDate: action.payload };

    case UPT_TO_SERVER:
      return { ...state, loading: true, unsave:true };

    case SET_ACTIVE:
      return { ...state, loading: true, unsave:true };
    
    case SET_FORCE:
      return { ...state, loading: true, unsave:true };
    
    case SURVEY_LIST_DEL:
      return { ...state, loading: false };

    case SURVEY_LIST_DEL_SUCCESS:
      return {
        ...state,
        loading: true,
        allSurveyItems: action.payload,
      };

    case SURVEY_LIST_DEL_ERROR:
      return { ...state, loading: true, error: action.payload };
    
    case FETCH_USER:
      return { ...state, loading: true, surveyAssign: action.payload };

    case UPT_USER:
      state.surveyAssign = []
      return { ...state, loading: true, surveyAssign: action.payload };

    case UPT_LAUNCH:
      return { ...state, loading: true, launchDate: action.payload };

    case UPT_LAUNCH_SERVER:
      return { ...state, loading: true, unsave:true };

    case SET_LOAD:
      return { ...state, loading: action.payload, unsave:true };

    default:
      return { ...state };
  }
};
